import creator from './creator';
import storage from '../core/storage';
import {
  SEARCH_INIT,
  FETCH_SEARCH_START,
  FETCH_SEARCH_END,
  FETCH_SEARCH_MORE_START,
  FETCH_SEARCH_MORE_END,
  DELETE_SEARCH_HISTORY,
  FETCH_HOT_WORDS,
} from '../constants';

// 初始化
export const init = creator(SEARCH_INIT, 'searchHistory')
export function searchInit() {
  return function searchInitAction(dispatch) {
    const storageData = storage.load()
    dispatch(init(storageData ? storageData.searchHistory : null))
  }
}

export const fetchSearchStart = creator(FETCH_SEARCH_START, 'item')
export const fetchSearchEnd = creator(FETCH_SEARCH_END, 'data')
export const fetchSearchMoreStart = creator(FETCH_SEARCH_MORE_START, 'item', 'start')
export const fetchSearchMoreEnd = creator(FETCH_SEARCH_MORE_END, 'data')
export const deleteHistory = creator(DELETE_SEARCH_HISTORY)
export const fetchGetHotWords = creator(FETCH_HOT_WORDS, 'data')

export function deleteSearchHistory() {
  return function deleteHistoryAction(dispatch) {
    dispatch(deleteHistory())
    storage.save({
      searchHistory: [],
    })
  }
}

export function fetchSearch(item) {
  return async function fetchSearchAction(dispatch, getState, { ds }) {
    dispatch(fetchSearchStart(item))
    try {
      const resp = await ds.historyResult(item)
      const { data } = await resp.json()
      dispatch(fetchSearchEnd(data))
      storage.save({
        searchHistory: getState().search.searchHistory,
      })
    } catch (err) {
      console.log(err) // eslint-disable-line no-console
    }
  }
}

export function fetchSearchMore(item, start) {
  return async function fetchSearchMoreAction(dispatch, getState, { ds }) {
    dispatch(fetchSearchMoreStart(item, start))
    try {
      const resp = await ds.historyResultMore(item, start)
      const { data } = await resp.json()
      dispatch(fetchSearchMoreEnd(data))
    } catch (err) {
      console.log(err) // eslint-disable-line no-console
    }
  }
}

export function fetchHotWords(tag) {
  return async function featchHotWordsAction(dispatch, getState, { ds }) {
    try {
      const resp = await ds.getHotWords(tag)
      const { data } = await resp.json()
      dispatch(fetchGetHotWords(data))
    } catch (err) {
      console.log(err)
    }
  }
}




// WEBPACK FOOTER //
// ./src/actions/search.js